module.exports = __webpack_public_path__ + "img/boy.3853d445.png";